export interface IDirectDebitDetails {
  fullName?: string;
  sortCode?: string;
  accountNumber?: string;
  accountHolderMandate?: boolean;
  creditCheckAgreement?: boolean;
  validated?: boolean;
}
